export default __webpack_public_path__ + "static/media/crash-logo.90fa8976.png";